import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-school-search",
	templateUrl: "./school-search.component.html",
})
export class SchoolSearchComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
